import * as $ from "jquery"
import "select2"
import "material-design-lite"
import "materialize-css"
import "jquery-validation"
import "jquery-validation-unobtrusive"
import "jquery-ajax-unobtrusive"
import "tether-tooltip"

const dataIsUpgradedAttr = "data-is-upgraded";

$(document).ready(() => {

    // Mobile menu activator
    $("#drawer-button").click(() => {
        $("#left-nav").toggleClass("is-visible");
    });
    $("#layout-obfuscator").click(() => {
        $("#left-nav").toggleClass("is-visible");
    });

    $.extend({
        initializeMaterialize: () => {
            // Remove empty placeholder attributes from inputs for better materialize display
            $('input[placeholder=""]').removeAttr("placeholder");

            // Setup materialize dropdowns
            ($(".dropdown-trigger") as any).selectIfNotUpgraded().upgraded().dropdown();

            $("select:empty").html("<option></option>");

            // Setup select2
            ($("select.select2") as any).selectIfNotUpgraded().select2({
                width: "100%"
            }).upgraded();

            // Setup materialize select
            ($("select:not(.select2)") as any).selectIfNotUpgraded().upgraded().formSelect();

            // Date picker
            $(".datepicker").each((i, elem) => {
                const $elem = $(elem);

                if ($elem.is(`[${dataIsUpgradedAttr}]`)) {
                    return;
                }

                $elem.pickadate({
                    selectMonths: true,
                    selectYears: 15,
                    today: ($elem.data("today-label") === undefined ? "" : $elem.data("today-label")),
                    clear: ($elem.data("clear-label") === undefined ? "" : $elem.data("clear-label")),
                    close: "Close",
                    onSet: function (thingSet) {
                        if (thingSet.select != undefined) {
                            this.close();
                        }
                    }
                });

                ($elem as any).upgraded();
            });
        }
    });

    $.fn.upgraded = function () {
        this.each(function () {
            $(this).attr(dataIsUpgradedAttr, "true");
        });
        return $(this);
    };

    $.fn.selectIfNotUpgraded = function () {
        return $(this).not(`[${dataIsUpgradedAttr}]`);
    };

    ($ as any).initializeMaterialize();

    $(".alert span.dismiss").click(e => {
        var alert = $(e.target).parents(".alert");
        alert.hide(400);
    });

    $(document).on("click",
        ".global-todo .dismiss",
        () => {
            $(".global-todo").hide();

            // todo: persist this choice
        });

    var fontSizeChooserForm = document.getElementById("font-size-chooser-form") as HTMLFormElement;

    if (fontSizeChooserForm != null) {
        var chosenFontSizeElement = document.getElementById('chosen-font-size') as HTMLInputElement;

        var buttons = fontSizeChooserForm.getElementsByTagName("button") as NodeListOf<HTMLButtonElement>;

        for (var i = 0, len = buttons.length; i < len; i++) {
            var button = buttons[i] as HTMLButtonElement;
            button.addEventListener("click", (ev) => {

                let selection = ev.currentTarget as HTMLButtonElement;
                chosenFontSizeElement.value = selection.attributes.getNamedItem("data-font-size").value;

                console.log(chosenFontSizeElement.value);
            });
        }
    }
});
